import {BaseService} from "./base.service";

class SupplierLaboratoriesService extends BaseService {

    constructor() {
        super('api/laboratories')
    }
}

export const supplierlaboratoriesService = new SupplierLaboratoriesService();
